<template>
    <div class="flex-1 flex justify-end mr-[72px] max-xl:mr-[28px] h-full">
        <div
            :class="css.navigations"
            class="relative max-lg:first:hidden group"
            v-for="(n1, k1) in vars.navigations"
            :key="k1"
            @mouseenter="visible = -1">
            <!-- * 导航名称 -->
            <div :class="[css.assets, classify.navigation]" v-if="!n1.route">{{ n1.name }}</div>
            <ProjectRoute :class="[css.assets, classify.navigation]" target="_self" :to="n1.route" v-else>
                {{ n1.name }}
            </ProjectRoute>

            <!-- * 子导航 -->
            <div :class="css.childrens" class="absolute top-[100%] left-0" v-show="n1.childrens?.length">
                <div class="mt-[4px] border border-solid border-uicolor4/15 bg-white rounded-[4px] flex">
                    <div class="py-[8px]">
                        <template v-for="(n2, k2) in n1.childrens" :key="k2">
                            <div :class="[classify.children, visible == k2 && 'bg-[#F5F5F5] text-main']" v-if="!n2.route" @mouseenter="visible = k2">
                                {{ n2.name }}
                            </div>
                            <ProjectRoute
                                :class="[classify.children, visible == k2 && 'bg-[#F5F5F5] text-main']"
                                target="_self"
                                :to="n2.route"
                                @mouseenter="visible = k2"
                                v-else>
                                {{ n2.name }}
                            </ProjectRoute>
                        </template>
                    </div>

                    <template v-for="(n2, k2) in n1.childrens" :key="k2">
                        <div :class="css.threes" class="py-[8px] px-[24px] bg-[#F5F5F5]" v-show="visible == k2 && n2.childrens?.length">
                            <div v-for="(n3, k3) in n2.childrens" :key="k3">
                                <div :class="classify.three" v-if="!n3.route">{{ n3.name }}</div>
                                <ProjectRoute :class="classify.three" target="_self" :to="n3.route" v-else>
                                    {{ n3.name }}
                                </ProjectRoute>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "../../index.module.less";

//* 组合函数
const { vars, refs, classify } = useComposable();
const { visible } = refs;
</script>
